export const scrollToAnchor = (e: any, btnLink: string) => {
  e.preventDefault();
  const element = document.getElementById(btnLink.substring(1));
  const headerOffset = -80;
  if (element) {
    const y = element.getBoundingClientRect().top + window.pageYOffset + headerOffset;
    element && window.scrollTo({ top: y, behavior: 'smooth' });
  }
};
